import { render, staticRenderFns } from "./AdminTab_Gateways.vue?vue&type=template&id=1c3613aa&scoped=true"
import script from "./AdminTab_Gateways.vue?vue&type=script&lang=js"
export * from "./AdminTab_Gateways.vue?vue&type=script&lang=js"
import style0 from "./AdminTab_Gateways.vue?vue&type=style&index=0&id=1c3613aa&prod&scoped=true&lang=css"
import style1 from "./AdminTab_Gateways.vue?vue&type=style&index=1&id=1c3613aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3613aa",
  null
  
)

export default component.exports